import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Card, Alert } from "react-bootstrap";
import { ORDER_UPDATE_RESET } from "../../constants/pickupOrderConstant";
import "./../Form.scss";
// import imageCompression from "browser-image-compression";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {
  useCreateSellerMutation,
  useNewCreateSellerMutation,
} from "../../api/deviceSellerApi";
import { ClipLoader } from "react-spinners";
import { useGetOrdersByIdQuery } from "../../api/orderListApi";

// import {
//   createCustomerCRMAction,
//   createCustomerCRMAction1,
// } from "../../actions/sellerInfoAction";
import { PropagateLoader } from "react-spinners";
import CustomerInfoInput from "./CustomerInfoInput";
import { MDBBtn } from "mdb-react-ui-kit";
import { pickupOrederDetail } from "../../actions/pickupOrderAction";
import CustomerDocumentInput from "./CustomerDocumentInput";

// Define your validation schema
const schema = yup.object().shape({
  user: yup.string().required("User is required"),
  phone_number: yup.string().required("Phone Number is required"),
  email: yup.string().required("Email is required"),
  dob: yup.string().required("Date of Birth is required"),
  product: yup.string().required("Product is required"),
  brand: yup.string().required("Brand is required"),
  final_price: yup
    .number()
    .typeError("Device Cost must be a number")
    .required("Device Cost is required"),
  ram: yup.string().required("ram is required"),
  storage: yup.string().required("storage is required"),
  warrenty: yup
    .object()
    .shape({
      value: yup.string().required("Warranty is required"),
    })
    .nullable()
    .required("Warranty is required"),

  payment: yup
    .object()
    .shape({
      value: yup.string().required("Payment Model is required"),
    })
    .nullable()
    .required("Payment Mode is required"),
  upi: yup.string().required("UPI ID is required"),
  imei: yup.string().required("imei is required"),
  device_color: yup.string().required("device color is required"),
  pick_up_location: yup.string().required("Address is required"),
  aadhaar_front_image: yup.mixed().required("Front image is required"),
  aadhaar_back_image: yup.mixed().required("Back image is required"),
  digital_signature: yup.string().required("Signature is required"),
});

export default function CreateCustomerCRM() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // const createSellerInfo = useSelector((state) => state.updateSellerInfo);
  // const { loading: sellerLoading, success: createSellerSuccess } =
  //   createSellerInfo;
  const [
    createSeller,
    {
      isLoading: sellerLoading,
      isSuccess: createSellerSuccess,
      isError: createSellerError,
    },
  ] = useCreateSellerMutation();
  const [
    newCreateSeller,
    {
      isLoading: newSellerLoading,
      isSuccess: newCreateSellerSuccess,
      isError: newCreateSellerError,
    },
  ] = useNewCreateSellerMutation();

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  // const orderDetail = useSelector((state) => state.orderDetail);
  // const { order_detail, loading: isLoading, error: oError } = orderDetail;
  const orderUpdate = useSelector((state) => state.orderUpdate);
  const { order_update } = orderUpdate;
  const { id } = useParams();
  const getOrderDetails = useGetOrdersByIdQuery(id);
  const {
    isError: oError,
    isLoading,
    isSuccess,
    data: order_detail,
  } = getOrderDetails;

  // const [filesState, setFilesState] = useState({
  //   aadhaar_front_image: null,
  //   aadhaar_back_image: null,
  //   documents: [],
  // });
  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      user: order_detail?.user,
      final_price: order_detail?.final_price,
      pick_up_location: order_detail?.pick_up_location,
      phone_number: order_detail?.phone_number,
      product: order_detail?.product,
      brand: order_detail?.brand_name,
      email: order_detail?.email,
    },
  });

  // useEffect(() => {
  //   if (createSellerSuccess) {
  //     navigate("/crm");
  //   }
  // }, [createSellerSuccess, navigate]);

  useEffect(() => {
    if (newCreateSellerSuccess) {
      navigate("/crm");
    }
  }, [newCreateSellerSuccess, navigate]);

  useEffect(() => {
    if (order_detail) {
      setValue("user", order_detail?.user);
      setValue("final_price", order_detail.final_price);
      setValue("pick_up_location", order_detail.pick_up_location);
      setValue("phone_number", order_detail?.phone_number);
      setValue("brand", order_detail?.brand);
      setValue("product", order_detail?.product);
      setValue("email", order_detail?.email);
    }
  }, [order_detail, setValue]);

  useEffect(() => {
    if (order_update) {
      setTimeout(() => {
        navigate("/orders", { replace: true });
      }, 1000);
    }
    dispatch({ type: ORDER_UPDATE_RESET });
  }, [order_update, navigate, dispatch]);

  // useEffect(() => {
  //   dispatch(pickupOrederDetail(id));
  // }, [id, dispatch]);

  async function uploadToS3(file) {
    const res = await fetch(
      `/api/v1/crm/get-presigned-url?file_name=${encodeURIComponent(
        file.name
      )}&file_type=${file.type}`,
      { method: "GET" }
    );

    const { upload_url, file_url } = await res.json();

    await fetch(upload_url, {
      method: "PUT",
      headers: { "Content-Type": file.type },
      body: file,
    });

    return file_url;
  }

  const compressImage = (file) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const reader = new FileReader();

      reader.onload = (event) => {
        img.src = event.target.result;
      };

      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const width = 1200; // Desired width
        canvas.width = width;
        canvas.height = (img.height * width) / img.width;

        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        canvas.toBlob(
          (blob) => {
            blob ? resolve(blob) : reject(new Error("Compression failed"));
          },
          "image/jpeg",
          0.75
        ); // Adjust quality as needed
      };

      reader.readAsDataURL(file);
    });
  };

  const newCompressImage = (file) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const reader = new FileReader();

      reader.onload = (event) => {
        img.src = event.target.result;
      };

      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const width = 1200;
        canvas.width = width;
        canvas.height = (img.height * width) / img.width;

        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        canvas.toBlob(
          (blob) => {
            if (!blob) return reject(new Error("Compression failed"));

            // 🔥 Convert Blob → File
            const compressedFile = new File(
              [blob],
              file.name.replace(/\.[^/.]+$/, ".jpg"),
              { type: "image/jpeg" }
            );

            resolve(compressedFile);
          },
          "image/jpeg",
          0.75
        );
      };

      reader.readAsDataURL(file);
    });
  };

  function base64ToFile(base64String, fileName = "signature.png") {
    const arr = base64String.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], fileName, { type: mime });
  }

  async function prepareImage(file) {
    let processed = file;

    if (file.size > 1 * 1024 * 1024) {
      processed = await compressImage(file);
    }
    return await uploadToS3(processed);
  }

  const orderSubmitForm2 = async (data) => {
    // Create FormData instance
    setIsButtonDisabled(true);
    const formData = new FormData();
    // Add non-file fields (all other form fields) to FormData
    formData.append("order_id", Number(id));
    formData.append("final_price", data["final_price"]);
    formData.append("customer_address", data["pick_up_location"]);
    formData.append("imei_num", data["imei"]);
    formData.append("name_on_document", data["user"]);
    formData.append("email", data["email"]);
    formData.append("customer_mobile", data["phone_number"]);
    formData.append("ram", data["ram"]);
    formData.append("storage", data["storage"]);
    formData.append("product_brand", data["brand"]);
    formData.append("product_model", data["product"]);
    formData.append("dob", data["dob"]);
    formData.append("warranty", data["warrenty"]["label"]);
    formData.append("upi_id", data["upi"]);
    formData.append("payment_model", data["payment"]["value"]);
    formData.append("device_color", data["device_color"]);
    formData.append("signature", data["digital_signature"]);
    // Validate and append documents
    const validateImage = (file) => {
      const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (!allowedTypes.includes(file.type) || file.size > 10 * 1024 * 1024) {
        alert("Invalid file. Please upload a JPEG/PNG image under 10MB.");
        return false;
      }
      return true;
    };

    // Process documents
    for (const key in data) {
      if (key.startsWith("document_")) {
        const documentIndex = parseInt(key.split("_")[1]);
        const documentValue = data[key];
        const documentImageKey = `document_image${documentIndex}`;
        const documentImageValue = data[documentImageKey];

        if (documentValue && documentImageValue) {
          if (documentImageValue[0] instanceof File) {
            const file = documentImageValue[0];
            if (validateImage(file)) {
              let imageToUpload = file;

              // Compress the image only if it exceeds 1MB (1MB = 1024 * 1024 bytes)
              if (file.size > 1 * 1024 * 1024) {
                imageToUpload = await compressImage(file);
              }

              // const compressedImage = await compressImage(file);
              const fileName = `document_${file}.jpg`;
              // Add document type and image file directly to FormData
              formData.append(
                `documents[${documentIndex}][document_type]`,
                documentValue.label
              );
              formData.append(
                `documents[${documentIndex}][document_image]`,
                imageToUpload,
                `${fileName}`
              );
            } else {
              return; // Invalid image, stop processing
            }
          }
        }
      }
    }

    const compressAndAppendImage = async (image, formData, fieldName) => {
      // const compressedImage = await compressImage(image);
      let imageToUpload = image;

      // Compress the image only if it exceeds 1MB (1MB = 1024 * 1024 bytes)
      if (image.size > 1 * 1024 * 1024) {
        imageToUpload = await compressImage(image);
      }

      formData.append(fieldName, imageToUpload, `${fieldName}.jpg`);
    };
    // Process Aadhaar images
    if (data.aadhaar_front_image[0] && data.aadhaar_back_image[0]) {
      const aadhaarFrontImage = data.aadhaar_front_image[0];
      const aadhaarBackImage = data.aadhaar_back_image[0];

      // Validate images together before processing
      if (validateImage(aadhaarFrontImage) && validateImage(aadhaarBackImage)) {
        await Promise.all([
          compressAndAppendImage(
            aadhaarFrontImage,
            formData,
            "aadhaar[front_image]"
          ),
          compressAndAppendImage(
            aadhaarBackImage,
            formData,
            "aadhaar[back_image]"
          ),
        ]);
      } else {
        return;
      }
    }
    await createSeller(formData).unwrap();
    setIsButtonDisabled(false);
  };

  const orderSubmitForm3 = async (data) => {
    setIsButtonDisabled(true);

    try {
      // ---------------------------
      // 1. Prepare JSON payload
      // ---------------------------
      const payload = {
        order_id: Number(id),
        final_price: data["final_price"],
        customer_address: data["pick_up_location"],
        imei_num: data["imei"],
        name_on_document: data["user"],
        email: data["email"],
        customer_mobile: data["phone_number"],
        ram: data["ram"],
        storage: data["storage"],
        product_brand: data["brand"],
        product_model: data["product"],
        dob: data["dob"],
        warranty: data["warrenty"]["label"],
        upi_id: data["upi"],
        payment_model: data["payment"]["value"],
        device_color: data["device_color"],
        new_signature: null,
        customersellerinfo: [],
        aadhaar_documents: {},
      };

      // ---------------------------
      // 2. Upload SIGNATURE
      // ---------------------------
      if (data["digital_signature"]) {
        // const signatureFile = data["digital_signature"];
        const signatureFile = base64ToFile(
          data.digital_signature,
          "signature.png"
        );
        const signatureUrl = await prepareImage(signatureFile);
        payload.new_signature = signatureUrl;
      }

      // ---------------------------
      // 3. Process DOCUMENTS
      // ---------------------------
      for (const key in data) {
        if (key.startsWith("document_")) {
          const index = parseInt(key.split("_")[1]);
          const documentType = data[key];

          const fileInputKey = `document_image${index}`;
          const fileWrapper = data[fileInputKey];

          if (fileWrapper && fileWrapper[0] instanceof File) {
            const file = fileWrapper[0];
            const imageUrl = await prepareImage(file);

            payload.customersellerinfo.push({
              document_type: documentType.label,
              new_document_image: imageUrl,
            });
          }
        }
      }

      // ---------------------------
      // 4. Aadhaar Front/Back
      // ---------------------------
      if (data.aadhaar_front_image[0] && data.aadhaar_back_image[0]) {
        const frontUrl = await prepareImage(data.aadhaar_front_image[0]);
        const backUrl = await prepareImage(data.aadhaar_back_image[0]);

        payload.aadhaar_documents = {
          new_front_image: frontUrl,
          new_back_image: backUrl,
        };
      }

      // ---------------------------
      // 5. FINAL API CALL
      // ---------------------------
      await newCreateSeller(payload).unwrap();
    } catch (error) {
      console.error("Error submitting form:", error);
    }

    setIsButtonDisabled(false);
  };

  return (
    <>
      <div className="order-form">
        {isLoading && (
          <div className="loading-container">
            <PropagateLoader color="#36d7b7" />
          </div>
        )}
        {oError && (
          <div className="error-container">
            <Alert variant="danger" style={{ backgroundColor: "#ffffff" }}>
              <Alert.Heading>Error</Alert.Heading>
              <p>{oError}</p>
            </Alert>
          </div>
        )}
        {order_detail && (
          <>
            <Card>
              {/* <form onSubmit={handleSubmit(orderSubmitForm2)}> */}
              <form onSubmit={handleSubmit(orderSubmitForm3)}>
                <div className="custom-border">
                  <CustomerInfoInput
                    order_detail={order_detail}
                    control={control}
                    errors={errors}
                  />
                  <CustomerDocumentInput
                    control={control}
                    seller_info_list={order_detail}
                    errors={errors}
                  />
                </div>
                {/* {createSellerError && (
                  <p style={{ color: "red" }}>{createSellerError}</p>
                )} */}
                {newCreateSellerError && (
                  <p style={{ color: "red" }}>{newCreateSellerError}</p>
                )}

                <div className="update-btton-container">
                  {/* <MDBBtn
                    className={`${(sellerLoading || isButtonDisabled) ? "dimmed-button" : ""}`}
                    type="submit"
                    style={{ height: "2.5rem", width: "6rem" }}
                    block
                  >
                    {(sellerLoading || isButtonDisabled)  && <ClipLoader color="#36d7b7" size={20} />}
                    Update
                  </MDBBtn> */}
                  <MDBBtn
                    className={`${
                      newSellerLoading || isButtonDisabled
                        ? "dimmed-button"
                        : ""
                    }`}
                    type="submit"
                    style={{ height: "2.5rem", width: "6rem" }}
                    block
                  >
                    {(newSellerLoading || isButtonDisabled) && (
                      <ClipLoader color="#36d7b7" size={20} />
                    )}
                    Update
                  </MDBBtn>
                </div>
              </form>
            </Card>
          </>
        )}
      </div>
    </>
  );
}
